import { Popover } from '@mui/material'
import clsx from 'clsx'
import { Button, Icon, ModalConfirm, TailwindPopOver } from 'components'
import { OrderPositionModal } from 'components/modal/Content/OrderPositionModal'

import { ContentActionCellProps, ContentListItem, Icons } from 'interfaces'
import React, { useState } from 'react'
import { canBeEdited } from 'utils'

export const ContentActionCell: React.FC<ContentActionCellProps> = ({
	data,
	editHandler,
	copyHandler,
	deactivateHandler,
	deleteHandler,
	pinHandler,
	dataNotification,
	isOrder,
	pinHandlerOrder,
	showPublishedButton = true
}) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
	const [modalConfirm, setModalConfirm] = useState<number | null>(null)

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = (): void => {
		setAnchorEl(null)
	}

	const editpushAndContent = (): void => {
		if (data) {
			editHandler(
				data.id_content || data.content_id
					? data.id_content || data.content_id
					: data.id
					? data.id
					: data.partner_organization_content_id,
				data.content_category,
				data.type
			)
		}
	}

	const copyPush = (withPushNotification: boolean): void => {
		if (data) {
			const idToUse =
				data?.id_content ?? data?.id ?? data?.partner_organization_content_id

			const contentCategory = data?.content_category
			copyHandler(idToUse, contentCategory, withPushNotification)
		}
	}

	const open = Boolean(anchorEl)
	const id = open ? 'simple-popover' : undefined

	return (
		<div className="flex gap-1 items-center">
			<Button
				iconLeft={Icons.pending}
				className="!w-max !min-w-[unset] !px-1 py-1 !border-none"
				color="Gray2"
				leftIconDivClassName="w-[20px] h-[20px]"
				onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
					handleClick(event)
				}}
			/>
			{!dataNotification && (
				<div className="flex">
					{isOrder && (
						<div
							aria-hidden="true"
							className="w-[20px] h-[20px] cursor-pointer"
							onClick={() => pinHandler()}
						>
							<Icon
								src={data?.is_pinned ? Icons.pushPin : Icons.pushPinActive}
								fillPath
								className={clsx(
									data?.is_pinned ? 'text-blue-primary' : 'text-gray-1'
								)}
							/>
						</div>
					)}
					{!isOrder && (
						<div
							aria-hidden="true"
							className="w-[20px] h-[20px] cursor-pointer"
							onClick={() => pinHandler()}
						>
							<Icon
								src={data?.is_pinned ? Icons.pushPin : Icons.pushPinActive}
								fillPath
								className={clsx(
									data?.is_pinned ? 'text-blue-primary' : 'text-gray-1'
								)}
							/>
						</div>
					)}
					{isOrder && (
						<div>
							<OrderPositionModal
								data={data}
								pinHandlerOrder={pinHandlerOrder}
							/>
						</div>
					)}
				</div>
			)}
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left'
				}}
				PaperProps={{ style: { borderRadius: '16px' } }}
			>
				<TailwindPopOver
					handleClose={handleClose}
					title="Actions"
					className="gap-4 w-[278px] h-max"
				>
					<>
						{(!dataNotification || canBeEdited(data as ContentListItem)) && (
							<Button
								label="Edit"
								className="!min-w-[unset] !w-full !py-2"
								iconLeft={Icons.edit}
								color="Transparent"
								onClick={() => editpushAndContent()}
							/>
						)}
						<Button
							label="Copy"
							className="!min-w-[unset] !w-full !py-2"
							iconLeft={Icons.copy}
							color="Transparent"
							onClick={() => {
								if (data?.has_notification) {
									setModalConfirm(1)
								} else {
									copyPush(false)
								}
							}}
						/>
						{data && !dataNotification && showPublishedButton && (
							<Button
								label={
									data.status === 'published' ? 'Set as a Draft' : 'Published'
								}
								className="!min-w-[unset] !w-full !py-2"
								iconLeft={
									data.status === 'published'
										? Icons.doNotDisturbOn
										: Icons.check
								}
								color="Transparent"
								onClick={() => {
									setAnchorEl(null)
									deactivateHandler()
								}}
							/>
						)}
						{data && data.status !== 'deleted' && (
							<Button
								label="Delete"
								className="!min-w-[unset] !w-full !py-2 text-[#FF3B30]"
								iconClassName="text-[#FF3B30]"
								iconLeft={Icons.delete}
								color="Gray3"
								onClick={() => deleteHandler()}
							/>
						)}
					</>
				</TailwindPopOver>
			</Popover>
			<ModalConfirm
				open={modalConfirm !== null}
				setOpen={() => setModalConfirm(null)}
				icon={Icons.help}
				descripcion="Would you like to copy this content with push?"
				buttonLabelCancel="No"
				buttonLabel="Yes"
				hasCancel
				onClickConfirm={() => copyPush(true)}
				handleCancel={() => copyPush(false)}
			/>
		</div>
	)
}
